import { useState } from "react";
import { SectionTitle } from "../_shared/section-title";
import { PageShell, Stack } from "../_shared/page-shell";
import { Card } from "../_shared/card";
import { IconSearchLarge } from "../_shared/icons";
import { tips, type Tip } from "../_data/mock";

const categories: { id: Tip["category"] | "all"; label: string }[] = [
  { id: "all", label: "Tout" },
  { id: "urgence", label: "Urgences" },
  { id: "hygiene", label: "Hygiène" },
  { id: "aligneur", label: "Aligneurs" },
  { id: "general", label: "Général" },
];

const catTone: Record<Tip["category"], string> = {
  urgence: "bg-red-100 text-red-700",
  hygiene: "bg-emerald-100 text-emerald-700",
  aligneur: "bg-sky-100 text-sky-700",
  general: "bg-[var(--surface-2)] text-[var(--text-2)]",
};

export function AstucesPage() {
  const [filter, setFilter] = useState<Tip["category"] | "all">("all");
  const [query, setQuery] = useState("");

  const visible = tips.filter((t) => {
    if (filter !== "all" && t.category !== filter) return false;
    if (
      query &&
      !t.question.toLowerCase().includes(query.toLowerCase()) &&
      !t.excerpt.toLowerCase().includes(query.toLowerCase())
    )
      return false;
    return true;
  });

  return (
    <>
      <SectionTitle title="Astuces" />
      <PageShell>
        <Stack>
          <label className="flex h-12 items-center gap-2 rounded-full bg-[var(--surface-1)] px-4 shadow-[0_1px_2px_rgba(15,23,42,0.06)] ring-1 ring-[var(--border-1)] focus-within:ring-2 focus-within:ring-[var(--sf-primary)]">
            <IconSearchLarge
              width={18}
              height={18}
              className="text-[var(--text-3)]"
            />
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Rechercher une astuce…"
              className="min-w-0 flex-1 bg-transparent text-base outline-none placeholder:text-[var(--text-3)]"
            />
          </label>

          <ul className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1">
            {categories.map((c) => {
              const active = filter === c.id;
              return (
                <li key={c.id} className="shrink-0">
                  <button
                    type="button"
                    onClick={() => setFilter(c.id)}
                    className={`inline-flex h-9 items-center rounded-full px-3.5 text-[12.5px] font-semibold ring-1 transition ${active ? "bg-[var(--sf-primary)] text-white ring-[var(--sf-primary)]" : "bg-[var(--surface-1)] text-[var(--text-2)] ring-[var(--border-1)] hover:bg-[var(--surface-2)]"}`}
                  >
                    {c.label}
                  </button>
                </li>
              );
            })}
          </ul>

          {visible.length === 0 ? (
            <Card title="Aucun résultat">
              <p className="text-[13.5px] text-[var(--text-2)]">
                Essayez un autre mot-clé ou une autre catégorie.
              </p>
            </Card>
          ) : (
            visible.map((t) => (
              <Card
                key={t.id}
                title={t.question}
                multilineTitle
                onClick={() => {}}
              >
                <span
                  className={`inline-flex h-5 items-center rounded-full px-2 text-[10.5px] font-semibold uppercase tracking-wide ${catTone[t.category]}`}
                >
                  {categories.find((c) => c.id === t.category)?.label}
                </span>
                <p className="mt-2 text-[13.5px] leading-snug text-[var(--text-2)]">
                  {t.excerpt}
                </p>
              </Card>
            ))
          )}
        </Stack>
      </PageShell>
    </>
  );
}
